module.exports = __webpack_public_path__ + "img/aas_a.90123593.png";